import { createAction, createAsyncAction } from 'typesafe-actions';
import * as types from './stockAudit.types';
import { StockAuditFiltersType } from './stockAuditStore';

export const setFilters = createAction(types.SET_FILTERS, (filters: Partial<StockAuditFiltersType>) => ({ filters }))();
export const clearFilters = () => createAction(types.SET_FILTERS, (filters: Partial<StockAuditFiltersType>) => ({}))();
